import styled from 'styled-components';

export const NavBar = styled.div`
display: flex;
flex-direction: row;
align-items: center;
justify-content: space-between;
overflow: hidden;
position: fixed;
width: 100%;
height: 56px;
bottom: 0px;
background: #FFFFFF;
box-shadow: 0px -2px 14px rgba(0, 0, 0, 0.1);
z-index:10;
`;

export const NavItem = styled.div<{backgroundColor: string}>`
position: static;
display: flex;
flex-direction: column;
height:56px;
align-items:center;
justify-content: space-evenly;
color:'#92959A';
background-color:${props=>props.backgroundColor}
`;

export const NavItemText = styled.span`
position: static;
width: 75px;
margin-top: -13px;
font-family: 'nunito', sans-serif;
font-style: normal;
font-weight: 600;
font-size: 12px;
line-height: 20px;
text-align: center;
order:1;
letter-spacing: 0.01em;
align-self: stretch;
text-decoration: none;
color:${props=>props.color}

@media screen and (max-width: 360px) {
    width: 70px;
}

@media screen and (max-width: 320px) {
        width: 62px;
}

@media screen and (max-width: 280px) {
        width: 52px;
}

@media screen and (min-width: 400px) {
        width: 80px;
`;